import { render, staticRenderFns } from "./PrintPosDteLetterCompactLayout.vue?vue&type=template&id=95b80ab6"
import script from "./PrintPosDteLetterCompactLayout.vue?vue&type=script&lang=js"
export * from "./PrintPosDteLetterCompactLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports